import { Injectable } from '@angular/core';
import { CatalogCodeType, CATALOG_CODE } from '../../../../../shared/constants/catalog-codes';
import { AbstractCatalogOptionLoader } from './catalog-option-loader.service';

@Injectable()
export class UnloadTypeOptionLoader extends AbstractCatalogOptionLoader {
  getCatalogType(): CatalogCodeType {
    return CATALOG_CODE.UNLOAD_TYPE;
  }
}
